import { nonEmptyStringValidator } from '@vista/omnichannel-components-domain';
import { Validator } from '@vista-digital/validator';
export const defaultQuickNavigatorAssets = {
    closeButtonIconName: 'cross',
    loadingDataIconName: 'spinner',
    failedToLoadSitesModalErrorIconName: 'generic-error-message',
    failedToLoadFilmsModalErrorIconName: 'generic-error-message',
    failedToLoadScreeningDatesModalErrorIconName: 'generic-error-message',
    failedToLoadShowtimesModalErrorIconName: 'generic-error-message',
    noFilmsModalErrorIconName: 'film-info-message',
    noFilmsForSiteModalErrorIconName: 'film-info-message',
    noScreeningDatesModalErrorIconName: 'ticket-info-message',
    noSitesFoundModalIconName: 'location-info-message',
    noFilmsFoundModalIconName: 'film-info-message',
    noScreeningDatesFoundModalIconName: 'ticket-info-message',
    noShowtimesFoundModalIconName: 'ticket-info-message'
};
export const quickNavigatorAssetsValidator = Validator.object({
    closeButtonIconName: nonEmptyStringValidator,
    loadingDataIconName: nonEmptyStringValidator,
    failedToLoadSitesModalErrorIconName: nonEmptyStringValidator,
    failedToLoadFilmsModalErrorIconName: nonEmptyStringValidator,
    failedToLoadScreeningDatesModalErrorIconName: nonEmptyStringValidator,
    failedToLoadShowtimesModalErrorIconName: nonEmptyStringValidator,
    noFilmsModalErrorIconName: nonEmptyStringValidator,
    noFilmsForSiteModalErrorIconName: nonEmptyStringValidator,
    noScreeningDatesModalErrorIconName: nonEmptyStringValidator,
    noSitesFoundModalIconName: nonEmptyStringValidator,
    noFilmsFoundModalIconName: nonEmptyStringValidator,
    noScreeningDatesFoundModalIconName: nonEmptyStringValidator,
    noShowtimesFoundModalIconName: nonEmptyStringValidator
});
